<template>
  <div class="security">
    <div style="font-size: 24px; font-weight: bold;">安全设置</div>
    <a-divider></a-divider>
    <a-descriptions style="padding-left: 8px;" :column="1">
      <template #title>
        <span>用户信息</span>
      </template>
      <a-descriptions-item>
        <template #label>
          <span style="margin: initial; line-height: 24px;">用户名</span>
        </template>
        <pre style="margin: initial; line-height: 26px; white-space: break-spaces">{{ user.username }}</pre>
      </a-descriptions-item>
      <a-descriptions-item>
        <template #label>
          <span style="margin: initial; line-height: 24px;">昵称</span>
        </template>
        <pre style="margin: initial; line-height: 26px; white-space: break-spaces">{{ user.nickname }}</pre>
      </a-descriptions-item>
      <a-descriptions-item>
        <template #label>
          <span style="margin: initial; line-height: 24px;">邮箱</span>
        </template>
        <pre style="margin: initial; line-height: 26px; white-space: break-spaces">{{ user.email }}</pre>
      </a-descriptions-item>
      <a-descriptions-item>
        <template #label>
          <pre style="margin: initial; line-height: 26px;">ApiKey</pre>
        </template>
        <pre style="margin: initial; line-height: 26px; white-space: break-spaces">{{ user.apiKey }}</pre>
        <a-button v-if="user.apiKey === '******'" type="primary" size="small" style="margin-left: 20px;" @click="showApiKey">点击显示</a-button>
      </a-descriptions-item>
      <!--<a-descriptions-item label="推送次数"><pre style="margin: initial; line-height: 26px;">{{ proxyCount }}</pre></a-descriptions-item>-->
    </a-descriptions>
  </div>
</template>
<script>
export default {
  data () {
    return {
      user: {
        apiKey: '******'
      }
    };
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted () {
    const r = await this.$api().user.getUserInfo();
    this.user = r.data;
  }
};
</script>
<style scoped>
.security {
  height: 100%;
  width: 100%;
}
</style>
